module.exports = __webpack_public_path__ + "img/Error-403.bb2fb956.svg";